<template>
    <svg viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-circle-arrows">
        <path
            d="M2.16675 11.6667C2.16675 11.6667 2.26785 12.3744 5.19678 15.3033C8.12571 18.2322 12.8744 18.2322 15.8034 15.3033C16.8411 14.2656 17.5112 12.9994 17.8136 11.6667M2.16675 11.6667V16.6667M2.16675 11.6667H7.16675M18.8334 8.33333C18.8334 8.33333 18.7323 7.62563 15.8034 4.6967C12.8744 1.76777 8.12571 1.76777 5.19678 4.6967C4.15905 5.73443 3.48899 7.0006 3.18661 8.33333M18.8334 8.33333V3.33333M18.8334 8.33333H13.8334"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
export default {
    name: 'IconCircleArrows',
};
</script>

<style lang="scss" scoped>
.icon-circle-arrows {
    stroke: #4663ab;
}
</style>
